/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from "react";
import queryString from "query-string";

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from "../../components/RequestLoginErrorMessage";
import ServiceApi from "../../services/ServiceApi";
import { checkDeviceIOS } from '../../utils'

import "./style.scss";
import logo from "./image/logo_giganet.png";
import LoginForm from "./LoginForm";

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (
      !this.parameters.client_id ||
      !this.parameters.redirect_uri ||
      !this.parameters.response_type
    ) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = "gnet-body";
    document.title = "Giganet - Viacom Login";
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="gnet-container">
        <div className="gnet-container-logo">
          <img src={logo} alt="giganet" className="gnet-logo" />
        </div>
        <div className="gnet-title">
          <p className="gnet-title2">
            Entre com sua conta <strong>sougiganet</strong> para acessar ao
            conteúdo.
          </p>
        </div>
        {this._validateParams() ? (
          <LoginForm api={this.api} location={this.props.location} />
        ) : (
          <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate("RequestLoginErrorMessage")}
          />
        )}
        <div className=" footer-gnet mt-4 pt-2 mb-3 mb-lg-0">
          {
            checkDeviceIOS() ? '' : <div>
              <p className="mb-0">
                Ainda não tem uma conta <strong>sougiganet</strong>?
              </p>
              <a
                className="link-color font-weight-bold ml-1"
                href="https://app.sougiganet.com.br/"
              >
                Cadastre-se aqui.
              </a>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default WithLocalize(Login);
